import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import styles from "./styles.module.scss";
import useTranslation from "next-translate/useTranslation";
import {TRAINING_IDENTITY} from "../../../../utils/constants";
import cn from "classnames";
import {Button} from "@shopify/polaris";
import InputMask from "react-input-mask"

import {
  initialInputs, INPUT_AGREE,
  INPUT_COMMENT,
  INPUT_CV,
  INPUT_EMAIL,
  INPUT_NAME,
  INPUT_PHONE,
} from "../../TrainingCenter/AppForm/initialInputs";
import Alert from "../../../common/components/Alert";
import {phoneValidation} from "../../../../helpers/validation/phoneValidation";
import {sendEmail} from "../../../../helpers/requests/sendEmail";
import Loader from "../../../common/elements/Loader";
import TicketResult from "../../../common/components/TicketResult";
import {TRAINING_NAMESPACE} from "../../../../utils/i18nNameSpaces";
import Contact from "../Contact";
import Stack from "../../TrainingCenter/AppForm/Stack";


const Index = ({contactT, phone, email, stackList}) => {
  const {t, lang} = useTranslation(TRAINING_NAMESPACE);
  const [isLoading, setIsLoading] = useState(false);
  const [isSend, setIsSend] = useState(false);
  const [inputs, setInputs] = useState(null);

  const handleFormSubmit = useCallback(async (e) => {
    if (!inputs) {
      return;
    }
    e.preventDefault();

    let isValid = true;
    const state = {...inputs};
    for (const input in state) {
      state[input].validate();

      if (!state[input].isValid) {
        isValid = false;
      }
    }

    setInputs(state);

    if (!isValid) {
      return;
    }

    setIsLoading(true);

    const formData = new FormData();

    for (const input in state) {
      formData.append(state[input].name, state[input].value)
    }

    await sendEmail(formData, TRAINING_IDENTITY);
    setIsLoading(false);
    setIsSend(true);
  }, [inputs, t, contactT]);


  const handleInputValueChange = useCallback((event) => {
    if (!inputs) {
      return;
    }
    setInputs(state => {

      if (event?.target) {
        const name = event.target.name;
        const value = event.target.value;
        if (name === INPUT_AGREE) {
          state[name].setValue(event.target.checked.toString());
          return {...state};
        }

        if (name === INPUT_CV) {
          state[event.target.name].setValue(event.target.files[0]);
          return {...state};
        }

        if (name === INPUT_PHONE) {
          if (!phoneValidation(value)) {
            state[name].setValue(value.replace(/[^+0-9]+/g, ''));

            return {...state};
          }
        }

        state[name].setValue(value);
      } else {
        state[event.name].setValue(event.value);
      }

      return {...state};
    })
  }, [inputs, t, contactT])


  const showInput = useMemo(() => (name, type = "text", quickValidate = null) => {
    if (!inputs) {
      return;
    }
    const showError = !inputs[name].isValid;

    let input;

    if (name === INPUT_PHONE) {
      input = <InputMask name={name} onInput={quickValidate} mask="+99999999999999" maskChar=""
                         onChange={handleInputValueChange} value={inputs[name].value} placeholder="+"
                         className={styles["form__input"]}/>
    } else {
      input = <input
        type={type}
        className={styles["form__input"]}
        placeholder={t(`appForm.inputs.${name}.placeholder`)}
        name={name}
        onChange={handleInputValueChange}
        onInput={quickValidate}
        value={inputs[name].value}
      />
    }
    return (
      <label className={cn(styles["form__input-label"], {[styles["input--error"]]: showError})}>
        <span className={styles["form__input-title"]}>{t(`appForm.inputs.${name}.name`)}</span>
        {input}
        {showError && <div className={styles["error"]}><Alert message={inputs[name].error}/></div>}
      </label>
    );
  }, [inputs, t, contactT])

  const showAgree = useMemo(() => {
    if (!inputs) {
      return;
    }
    const showError = !inputs[INPUT_AGREE].isValid;

    return (
      <>
        <label className={cn(styles["form__agree-label"], {[styles["input--error"]]: showError})}>
          <input
            type="checkbox"
            className={styles["form__agree-input"]}
            name={INPUT_AGREE}
            onInput={handleInputValueChange}
          />
          <p className={styles["form__agree-desc"]}>{t("appForm.agree.desc")}</p>
          {showError && <div className={styles["error"]}><Alert message={inputs[INPUT_AGREE].error}/></div>}
        </label>
      </>
    )
  }, [inputs, t, contactT])

  useEffect(() => {
    setInputs(initialInputs(t));
  }, [lang])

  return (
    <section className={cn(styles["app-form"], {[styles["app-form--send"]]: isSend})} id="form">
      {isLoading && <Loader/>}
      <h3 className={styles["app-form__header"]}>{contactT(`form.header`)}</h3>
      <div className={styles["app-form__wrapper"]}>
        <div className={styles["app-form__container"]}>
          <Contact t={contactT} phone={phone} email={email}/>
          <div className={styles["form__wrapper"]}>
            {!isSend ?
              <form onSubmit={handleFormSubmit}>
                <div className={styles["form__container"]}>
                  <div className={styles["form__inputs-wrapper"]}>
                    {showInput(INPUT_NAME)}
                    {showInput(INPUT_PHONE, "text")}
                    {showInput(INPUT_EMAIL, "email")}
                    {stackList && <Stack handleInputValueChange={handleInputValueChange} stackList={stackList} extraT={contactT}/>}
                  </div>
                  <div className={styles["form__comment-wrapper"]}>
                    <label className={cn(styles["form__input-label"])}>
                      <p className={styles["form__input-title"]}>{t("appForm.inputs.comment.name")}</p>
                      <textarea
                        className={styles["form__input"]}
                        placeholder={t("appForm.inputs.comment.placeholder")}
                        maxLength={1600}
                        name={INPUT_COMMENT}
                        onInput={handleInputValueChange}
                      />
                    </label>
                  </div>
                </div>
                <footer>
                  <div className={styles["form__submit-wrapper"]}>
                    <div className={styles["form__agree-wrapper"]}>
                      {/*{showAgree}*/}
                    </div>
                    <div className={cn(styles["form__btn-wrapper"], "training-form__btn-wrapper")}>
                      <Button submit primary fullWidth>{t("appForm.btn")}</Button>
                    </div>
                  </div>
                </footer>
              </form>
              :
              <TicketResult/>
            }
          </div>
        </div>
      </div>
    </section>
  );
};

export default Index;